/** API client for fault analysis endpoints. */

import { get, put } from './client.ts'
import type {
  CombinedFaultStudyResult,
  DeviceRatingCoverageReport,
  FaultStudyResult,
  FaultStudySnapshot,
  ProtectionCoordinationResult,
} from '../types/faultAnalysis.ts'
import type {
  CoordinationFinding,
  CoordinationFindingList,
  Disposition,
  TccPairCurves,
} from '../types/tcc.ts'
import type { GeoJSONFeatureCollection } from '../types/topology.ts'

export function getCombinedFaultStudy(feederId: number): Promise<CombinedFaultStudyResult> {
  return get<CombinedFaultStudyResult>(`/engineering/fault-study/feeders/${feederId}/combined`)
}

export function getLatestFaultStudy(feederId: number): Promise<FaultStudySnapshot> {
  return get<FaultStudySnapshot>(`/engineering/fault-study/feeders/${feederId}/latest`)
}

export function persistFaultStudy(feederId: number): Promise<FaultStudyResult> {
  return get<FaultStudyResult>(`/engineering/fault-study/feeders/${feederId}?persist=true`)
}

export function getDeviceRatingCoverage(feederId: number): Promise<DeviceRatingCoverageReport> {
  return get<DeviceRatingCoverageReport>(`/engineering/device-rating-coverage/feeders/${feederId}`)
}

export function getProtectionTree(feederId: number): Promise<ProtectionCoordinationResult> {
  return get<ProtectionCoordinationResult>(`/engineering/protection-tree/feeders/${feederId}`)
}

export function getFaultCurrentGeoJSON(feederId: number): Promise<GeoJSONFeatureCollection> {
  return get<GeoJSONFeatureCollection>(`/map/conductors/fault-current?feeder_id=${feederId}`)
}

export function getTccPairCurves(
  feederId: number, upstreamId: number, downstreamId: number,
): Promise<TccPairCurves> {
  return get<TccPairCurves>(
    `/engineering/tcc-curves/pair?feeder_id=${feederId}` +
    `&upstream_device_id=${upstreamId}&downstream_device_id=${downstreamId}`,
  )
}
export function getCoordinationFindings(feederId: number): Promise<CoordinationFindingList> {
  return get<CoordinationFindingList>(`/engineering/coordination-findings/feeders/${feederId}`)
}
export function putCoordinationDisposition(body: {
  feeder_id: number; upstream_device_id: number; downstream_device_id: number
  disposition: Disposition; disposition_by?: string | null; notes?: string | null
}): Promise<CoordinationFinding> {
  return put<CoordinationFinding>('/engineering/coordination-findings', body)
}
